import handleAPIError, { showSuccessToast } from "../../services/toast";
import axiosInstance from "../../services/axiosInstance";
import { axiosWithAbort } from "../../services/axiosWithAbort";

export const emissionAPI = {
  ////////1.1 EFlist
  async getEMList(requestBody, routeCat) {
    const response = await axiosWithAbort("getEMList", {
      method: "POST",
      url: `/api/${routeCat}/emission/list/`,
      data: requestBody,
    });
    if (response === null) return null; // request was aborted
    return response.data.data;
  },

  // biomass emission列表
  async getBiomassEMList(requestBody, routeCat) {
    const response = await axiosWithAbort("getBiomassEMList", {
      method: "POST",
      url: `/api/${routeCat}/emission/list/biomass`,
      data: requestBody,
    });
    if (response === null) return null; // request was aborted
    return response.data.data;
  },

  // 觸發重新計算排放當量，回傳 taskId
  async recalculate(rootId, year) {
    const body = year != null ? { year } : {};
    const response = await axiosInstance.post(
      `/api/emissioncalculate/recalculate/root/${rootId}`,
      body
    );
    return response.data;
  },

  // 查詢重新計算任務的狀態
  async getRecalculateStatus(taskId) {
    const response = await axiosInstance.get(
      `/api/emissioncalculate/recalculate/status/${taskId}`
    );
    return response.data;
  },
};
